import React from "react";
import { UseFormRegisterReturn, FieldError } from "react-hook-form";

interface Option {
  value: string;
  label: string;
  disabled?: boolean;
}

interface SelectFieldProps {
  label: string;
  options: Option[];
  loading?: boolean;
  placeholder?: string;
  error?: FieldError;
  disabled?: boolean;
  className?: string;
  register?: UseFormRegisterReturn;
  helpText?: string;
}

export function SelectField({
  label,
  options,
  loading = false,
  placeholder,
  error,
  disabled = false,
  className = "",
  register,
  helpText,
}: SelectFieldProps) {
  return (
    <div className={className}>
      <label className="block text-gray-bb-1 font-medium mb-2">{label}</label>
      {helpText && (
        <p className="text-gray-bb-2 text-sm mb-2 uppercase">{helpText}</p>
      )}
      <select
        {...register}
        className={`w-full border rounded-lg p-3 focus:ring-2 focus:ring-blue-bb focus:border-transparent ${
          error ? "border-red-500" : "border-gray-bb-4"
        }`}
        disabled={loading || disabled}
      >
        <option value="">
          {loading ? "Carregando..." : placeholder || "Selecione..."}
        </option>
        {options.map((option, index) => (
          <option key={index} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        ))}
      </select>
      {error && (
        <p className="text-red-500 text-sm mt-1">{error.message}</p>
      )}
    </div>
  );
}